import { Grid, SxProps, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getDateString } from "../common/RoundHelper";
import { PoolXNumberFormat } from "../common/CurrencyFormatter";
import { Syndicate } from "../models/syndicate";
import { ShallowRound } from "../models/round";
import { DbetEightIcon, DbetEightLadder, DbetSevenIcon, DbetSixIcon, DbetHockeyNineLogo, DbetThirteenIcon, DbetThirteenLadder, DbetTwelveIcon, DbetTwelveLadder, DbetArrowRightTerminal } from "../images/dbeticons";
import roundTypeBg from '../images/dbet_round_type_background.png';
import { useState } from "react";
import SyndicateModal from "./syndicatemodal";
import useDetailRound from "../rounds/useDetailRound";
import useSyndicate from "../syndicates/useSyndicate";

function TerminalSyndicate({ syndicate, round }: { syndicate: Syndicate, round: ShallowRound }) {
    const [modalOpen, setModalOpen] = useState(false);
    const syndicateResponse = useSyndicate(syndicate.id);
    const { round: detailedRound } = useDetailRound(syndicate.roundId);

    const { t } = useTranslation();
    const dateString = getDateString(round, t);
    const { totalAmountPerShare } = syndicate || {};
    const { amount, currency } = totalAmountPerShare || {};

    let locale = t('locale');
    const nf = PoolXNumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    let formattedStakePerShare = nf.format(amount);

    if (syndicate === undefined || (syndicate.coupon === undefined && !syndicate.couponHidden)) {
        return (<></>);
    }

    const smallText: SxProps<Theme> = {
        fontSize: "16px",
        lineHeight: "120%",
        color: "#65ABE8",
        fontWeight: "500",
        fontFamily: 'Roboto',
        textDecoration: 'none',
    };

    const smallTitleUpper: SxProps<Theme> = {
        fontSize: "24px",
        color: '#C9F0FF',
        fontWeight: "700",
        fontFamily: 'Roboto',
        paddingLeft: '10px',
        paddingRight: '10px',
        textWrap: 'wrap',
        textAlign: 'center',
        textTransform: 'capitalize'
    };

    const stakeStyle: SxProps<Theme> = {
        fontSize: "28px",
        color: '#FFFFFF',
        fontWeight: "700",
        fontFamily: 'Roboto',
        textTransform: 'uppercase',
        textWrap: 'nowrap',
        textAlign: 'left'
    };

    let gradient = `url(${roundTypeBg})`;
    let numberIcon = (
        <Grid container direction="row" alignItems="center">
            <Grid sx={{ marginRight: "3.5px", paddingLeft: "39px" }}>
                {DbetEightIcon(50, 59)}
            </Grid>
            {DbetEightLadder(25, 20)}
        </Grid>
    );

    if (round.name.indexOf("Survivor6") > -1) {
        numberIcon = (
            <Grid container direction="row" alignItems="center">
                <Grid sx={{ marginRight: "3.5px", paddingLeft: "39px" }}>
                    {DbetSixIcon(50, 59)}
                </Grid>
                {DbetEightLadder(25, 20)}
            </Grid>
        );
    }

    if (round.name.indexOf("Hockey7") > -1) {
        numberIcon = (
            <Grid container direction="row" alignItems="center">
                <Grid sx={{ marginRight: "3.5px", paddingLeft: "38px" }}>
                    {DbetSevenIcon(50, 59)}
                </Grid>
                {DbetEightLadder(25, 20)}
            </Grid>
        );
    }

    if (round.name.indexOf("Hockey9") > -1) {
        numberIcon = (
            <Grid container alignItems="center" justifyContent="center">
                {DbetHockeyNineLogo(15, 131)}
            </Grid>
        );
    }

    if (round.name.indexOf("Max") > -1) {
        numberIcon = (
            <Grid container direction="row" alignItems="center">
                <Grid sx={{ marginRight: "3.5px", paddingLeft: "39px" }}>
                    {DbetThirteenIcon(50, 59)}
                </Grid>
                {DbetThirteenLadder(25, 20)}
            </Grid>
        );
    }

    if (round.name.indexOf("Mix") > -1) {
        numberIcon = (
            <Grid container direction="row" alignItems="center">
                <Grid sx={{ marginRight: "3.5px", paddingLeft: "30px" }}>
                    {DbetTwelveIcon(50, 59)}
                </Grid>
                {DbetTwelveLadder(25, 20)}
            </Grid>
        );
    }

    const handleClick = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false);
    };

    return (
        <>
            <Grid container flexWrap="nowrap" direction='row' alignItems="center" onClick={handleClick} sx={{
                width: "906px",
                height: "134px",
                borderRadius: "20px",
                marginBottom: "26px",
                textDecoration: 'none',
                color: 'inherit',
                cursor: 'pointer',
                '&:hover': {
                    opacity: 0.9,
                }
            }}>

            <Grid container direction='column' sx={{
                width: "175px",
                backgroundImage: gradient,
                backgroundSize: 'auto 100%',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: "134px",
                justifyContent: 'center',
                alignItems: 'center',
                borderTopLeftRadius: "20px",
                borderBottomLeftRadius: "20px"
            }}>
                <Grid item sx={{
                    width: "100%",
                    height: "auto",
                    backgroundSize: 'cover',
                    marginLeft: "0px",
                    marginRight: "0px",
                }}>

                    <Grid direction="column" container alignItems="center">
                        <Grid container direction="column" alignItems="center"
                            sx={{
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                padding: "20px"
                            }}
                        >
                            {round.name.indexOf("Hockey9") === -1 &&
                                <Typography sx={{
                                    fontSize: "20px",
                                    fontFamily: "Righteous",
                                    fontWeight: "400",
                                    textTransform: "uppercase",
                                    textAlign: "center",
                                    letterSpacing: "0%",
                                    color: "#F4C004"
                                }}>
                                    Super
                                </Typography>
                            }
                            {numberIcon}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container direction="row" alignItems="center" justifyContent="space-between"
                sx={{
                    width: "731px",
                    height: "134px",
                    backgroundColor: "#112F7C",
                    borderTopRightRadius: "20px",
                    borderBottomRightRadius: "20px",
                    paddingLeft: "30px",
                    paddingRight: "50px"
                }}>
                <Grid container sx={{
                    width: "187px",
                    height: "auto",
                    overflow: "hidden"
                }} direction='column' alignItems='center'>
                    <Typography sx={smallText}>{dateString}</Typography>
                    <Typography sx={{
                        ...smallTitleUpper,
                        width: "100%",
                        wordBreak: "break-word",
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden"
                    }}>{syndicate.name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}</Typography>

                </Grid>

                <Grid container direction="row" alignItems="center" justifyContent="space-between"
                    sx={{ width: "336px" }}>

                    <Grid container sx={{ width: "100px" }} direction='column' alignItems='center' justifyContent='center'>
                        <Typography sx={smallText}>{t('shares')}</Typography>
                        {syndicate.nSharesHidden ?
                            <Typography sx={smallTitleUpper}>{syndicate.targetNShares}</Typography>
                            :
                            <Typography sx={smallTitleUpper}>{'(' + syndicate.nShares + '/' + syndicate.targetNShares + ')'}</Typography>
                        }
                    </Grid>
                    <Grid sx={{ height: "50px", borderLeft: "4px solid #254BA4" }} />

                    <Grid container sx={{ width: "186px" }} direction='column' alignItems='center' justifyContent='center'>
                        <Typography sx={stakeStyle}>{formattedStakePerShare}</Typography>
                    </Grid>

                </Grid>

                <Grid sx={{ height: "44px", width: "44px", padding: "10px", borderRadius: "41px", backgroundColor: "#4075FF" }} >
                    {DbetArrowRightTerminal}
                </Grid>
            </Grid>
        </Grid>

            {detailedRound && (
                <SyndicateModal
                    open={modalOpen}
                    onClose={handleClose}
                    syndicateId={syndicate.id}
                    roundId={detailedRound.id}
                    purchase={syndicateResponse.purchase}
                    readonly={false}
                />
            )}
        </>
    );

}

export default TerminalSyndicate;
